import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { getBasePrice } from '../../reducers/prices';
import { getMessage } from '../../reducers/i18n';
import { getActiveProductId } from '../../reducers/products';

const BasePrice = ({ amount, currencySymbol, baseUnit, product }) => {
    const BasePriceWrapper = styled.div`
        font-size: ${props => props.theme.fontSizes[7]};
        text-align: right;
    `;

    if (product !== 'fabric') return null

    return (<BasePriceWrapper>
        <FormattedMessage
            id='UNIT_PRICE_PREFIX'
            description='Prices prefix for displaying unit prices.'
            defaultMessage='Grundpreis: '
        /> {amount.toFixed(2)} {currencySymbol}/{baseUnit}
    </BasePriceWrapper>);
};

BasePrice.propTypes = {
    currencySymbol: PropTypes.string,
    baseUnit: PropTypes.string,
    amount: PropTypes.number,
};

BasePrice.defaultProps = {
    currencySymbol: '€',
    baseUnit: 'lfm',
    amount: 999.99,
};

const mapStateToProps = state => ({
    baseUnit: getMessage(state, 'LENGTH_UNIT'),
    amount: parseFloat(getBasePrice(state)),
    product: getActiveProductId(state),
});

export default connect(mapStateToProps)(BasePrice);



// WEBPACK FOOTER //
// ./src/components/addtocart/BasePrice.js